import React, { useEffect, useState } from "react";
import { Form, Skeleton, message, Row, Col } from "antd";
import {
  SelectWithSearch,
  SaveButton,
  CancelButton,
  ModalComponent,
  trans,
  InputText, AddNewButton
} from "@comps/components";
import {
  makeRequest,
  makeRequestStateless,
  getErrorProps,
} from "@utils/helpers";
import { createSelectList } from "@comps/commonFunctions";
import { updateAreaReq, getLocationsAndManagersByCompanyIdReq } from "../requests";
import CreateLocation from '../../locations/components/CreateLocation';
import { Commons, Const } from "../../constants";

const langKey = Const["area"].lngKey;
const formName = "updateArea";

const UpdateArea = (props) => {
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [managers, setManagers] = useState([]);
  const [locations, setLocations] = useState([]);
  const [saving, setsaving] = useState(false);
  const [loading, setloading] = useState(true);
  const [childComponent, setChildComponent] = useState(null)

  useEffect(() => {
    setFormDataFromProps();
    getRemoteData(props.record.company_id)
    // eslint-disable-next-line
  }, []);

  const setFormDataFromProps = async () => {

    if (!props) {
      return
    }
    form.setFieldsValue({
      name: props.record.name,
      manager: props.record.manager_id,
      location_id: props.record.location_id,
    });

  };

  const onSubmit = (data) => {
    setsaving(true)
    if (!props.record) {
      return
    }
    const payload = { id: props.record.id, name: data.name, location_id: data.location_id, manager_id: data.manager }

    makeRequest(setLoader, updateAreaReq, payload, onSuccess, onError);
  };

  const onSuccess = (data, res) => {
    setsaving(false)
    message.success("Area updated successfully");
    props.onCompleted(data.areas.data);
  };

  const onError = (err, res) => {
    setsaving(false)
    message.error(res.response.data.message);
    //setErrors(errorList);
  }

  const getRemoteData = (companyId) => {
    if (companyId !== null) {
      makeRequestStateless(
        getLocationsAndManagersByCompanyIdReq,
        companyId,
        onLocationAndManagerSuccess,
        onLocationAndManagerError
      );
    }
  }

  const onLocationAndManagerSuccess = (res) => {
    setloading(false)
    setManagers(createSelectList(res.employments))
    setLocations(createSelectList(res.locations))
  }

  const onLocationAndManagerError = (res) => {
    message.error("Error getting Locations and Managers")
  }
  //when location created
  const onLocationCreated = (data) => {
    if (data.length) {

      setLocations(createSelectList(data))
      form.setFieldValue('location_id', data[0].id)
    }
    setChildComponent(null);
  };

  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    !props.disabled &&
    <SaveButton loading={ saving } disabled={ loader } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];
  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------
  return (
    <ModalComponent
      width={ 1000 }
      top={ 20 }
      maskClosable={ false }
      mainTitle={ trans(Commons[props.disabled ? 'view' : 'update']) }
      subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true }
      footer={ footer }
      onCancel={ () => props.onCompleted(false) }
    >
      { childComponent }
      <Skeleton loading={ loading }>
        <Form form={ form } layout="vertical" name={ formName } onFinish={ onSubmit } disabled={ props.disabled }>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item
                name="name"
                rules={ rules.name }
                label={ trans(`${langKey}.name`) }
                className="da-mb-16"
                { ...getErrorProps(errors["name"]) }
                size="small"
              >
                <InputText placeholder={ trans(`${langKey}.name`) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item
                name="manager"
                label={ trans(`${langKey}.selectManager`) }
                className="da-mb-16"
              >
                <SelectWithSearch
                  className="da-mb-16"
                  placeholder={ trans(`${langKey}.selectManager`) }
                  options={ managers }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <AddNewButton text="Location" onClick={ () => setChildComponent(<CreateLocation onCompleted={ onLocationCreated } />) } />
              <Form.Item
                name="location_id"
                label={ trans(`${langKey}.selectLocation`) }
                rules={ rules.location }
                className="da-mb-16"
                { ...getErrorProps(errors["location"]) }
              >
                <SelectWithSearch options={ locations } placeholder={ trans(`${langKey}.selectLocation`) } />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Skeleton>
    </ModalComponent>
  );
};
export default UpdateArea;

const rules = {
  name: [{ required: true, message: trans(`${langKey}.name.required`) }],
  location: [
    { required: true, message: trans(`${langKey}.location.required`) },
  ],
};